import { Col, Row } from "react-bootstrap";

export default function InputCheckbox({ label, items, name, register }) {
  return (
    <Row>
      <Col md={{ offset: 1, span: 4 }} className="align-middle">
        <label>{label}: </label>
      </Col>
      <Col md={6}>
        {items.map((item, index) => {
          const i = index + 1;
          const id = "workshop" + i;
          return (
            <div key={index}>
              <label className="checkbox-container">
                {item.title}
                <input
                  type="checkbox"
                  id={id}
                  name={name}
                  value={item.value}
                  {...register(name)}
                />
                <span className="checkmark-checkbox"></span>
              </label>
            </div>
          );
        })}
      </Col>
    </Row>
  );
}
